import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BedIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      opacity: "0.4",
      d: "M4.28125 2.91663V16.8816C4.28125 18.025 4.81792 19.11 5.73958 19.7983L11.8179 24.3483C13.1129 25.3166 14.8979 25.3166 16.1929 24.3483L22.2712 19.7983C23.1929 19.11 23.7296 18.025 23.7296 16.8816V2.91663H4.28125Z",
      fill: props.color ||'var(--primary-c600)'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M25.6673 3.79163H2.33398C1.85565 3.79163 1.45898 3.39496 1.45898 2.91663C1.45898 2.43829 1.85565 2.04163 2.33398 2.04163H25.6673C26.1457 2.04163 26.5423 2.43829 26.5423 2.91663C26.5423 3.39496 26.1457 3.79163 25.6673 3.79163Z",
      fill: props.color ||'var(--primary-c600)'
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M18.6673 10.2084H9.33398C8.85565 10.2084 8.45898 9.81171 8.45898 9.33337C8.45898 8.85504 8.85565 8.45837 9.33398 8.45837H18.6673C19.1457 8.45837 19.5423 8.85504 19.5423 9.33337C19.5423 9.81171 19.1457 10.2084 18.6673 10.2084Z",
      fill: props.color ||'var(--primary-c600)'
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M18.6673 16.0416H9.33398C8.85565 16.0416 8.45898 15.645 8.45898 15.1666C8.45898 14.6883 8.85565 14.2916 9.33398 14.2916H18.6673C19.1457 14.2916 19.5423 14.6883 19.5423 15.1666C19.5423 15.645 19.1457 16.0416 18.6673 16.0416Z",
      fill: props.color ||'var(--primary-c600)'
    }, null, 8, _hoisted_5)
  ]))
}
}

})